import React, { forwardRef, useImperativeHandle } from 'react';

// Styles
import './embedded-settings-tab.scss';

// Components
import { SettingsBlock } from '../settings-block/settings-block';
import { WidgetCodeBlock } from '../widget-code-block/widget-code-block';
import { PreviewBlock } from '../preview-block/preview-block';

// Models
import { IWidgetInfo } from '../../../../../../interfaces/widget-settings.interfaces';

export type TEmbeddedSettingsTabRef = {};

type TEmbeddedSettingsTabProps = {
  widget_settings: IWidgetInfo;
  loading: boolean;
};

export const EmbeddedSettingsTab = forwardRef<TEmbeddedSettingsTabRef, TEmbeddedSettingsTabProps>(
  ({ widget_settings, loading }: TEmbeddedSettingsTabProps, ref
  ) => {

    useImperativeHandle(ref, () => ({}));

    return (
      <div className="embedded-settings-tab">
        <div className="embedded-settings-tab--column">
          <SettingsBlock widget_settings={ widget_settings } type={ 'embedded' } loading={ loading }/>
          <WidgetCodeBlock widget_settings={ widget_settings } type={ 'embedded' }/>
        </div>
        <div className="embedded-settings-tab--column">
          <PreviewBlock widget_settings={ widget_settings } type={ 'embedded' }/>
        </div>
      </div>
    );
  })
